/**
 * Determines the platform based on the current URL
 * 
 * @returns {string} 'ENTERPRISE' or 'DEFAULT'
 */
export const getPlatformFromUrl = () => {
  const hostname = window.location.hostname;
  console.log('process.env.REACT_APP_PLATFORM', process.env.REACT_APP_PLATFORM);
  // If localhost, check the environment variable
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_PLATFORM || 'DEFAULT';
  }
  
  // If enterprise.medhaul.link, return ENTERPRISE
  if (hostname === 'enterprise.medhaul.link') {
    return 'ENTERPRISE';
  }
  
  // Default to DEFAULT for all other URLs
  return 'DEFAULT';
};